import styled from 'styled-components';

import { getDegreeOfRotation } from '@/helpers/wheel';

import { device } from '@/styles/helpers';

export interface ScWheelProps {
  size: number | 'auto';
}

export const ScWheelContainer = styled.div<ScWheelProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: ${({ size }) => (size === 'auto' ? `100%` : `${size}px`)};
  height: ${({ size }) => (size === 'auto' ? `0%` : `${size}px`)};
  margin: 39px auto;

  &,
  & .inner {
    position: relative;
    border-radius: 50%;
    z-index: 1;
  }

  & .inner {
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    margin: 0 auto;

    &::after,
    &::before {
      position: absolute;
      display: block;
      content: '';
      background: transparent;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 4px;
      background: ${({ theme }) => theme.goldGradient};
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      width: 100%;
      height: 100%;
    }

    &::after {
      width: calc(100% + 18px);
      height: calc(100% + 18px);
    }
  }
`;

interface ScWheelPrizesProps {
  isSpinning: boolean;
  winningPrizeIndex: number;
  totalPrizes: number;
}

export const ScWheelPrizes = styled.div<ScWheelPrizesProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  background: ${({ theme }) => theme.grayLightColor};
  transform: ${({ isSpinning, winningPrizeIndex, totalPrizes }) =>
    isSpinning
      ? `rotate(${
          90 + 360 * 10 + (360 / totalPrizes) * winningPrizeIndex * -1
        }deg)`
      : `rotate(${89 - getDegreeOfRotation(totalPrizes, 1) / 2}deg)`};
  transition: transform 7s;
`;

export const ScWheelArrow = styled.div<{ arrowImg: string }>`
  position: absolute;
  z-index: 3;
  width: 78px;
  height: 78px;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  background: url(${({ arrowImg }) => arrowImg}) center no-repeat;
  background-size: cover;

  @media (${device.mobile}) {
    width: 52px;
    height: 52px;
    right: -20px;
  }

  &::after {
    position: absolute;
    display: block;
    content: '';
    background: transparent;
    top: -2px;
    left: -2px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
  }
`;
